module.exports = "/static/media/vodafone.e147c1ee.svg";